import type { FormatStyle, FormatStyleObj } from '@formkit/tempo'
import { format as tempoFormat } from '@formkit/tempo'

type Format =
  | 'date'
  | 'datetime'
  | 'locale-date'
  | 'locale-long-date'
  | 'locale-mn'
  | 'locale-sec'
  | 'month-year'
  | FormatStyle
  | FormatStyleObj

export default function (
  date?: Date | null | string,
  format: Format = 'locale-mn',
  fallback = '',
) {
  if (!date)
    return fallback

  let formatToken

  switch (format) {
    case 'date':
      formatToken = 'YYYY-MM-DD'
      break
    case 'datetime':
      formatToken = 'YYYY-MM-DDTHH:mm:ss'
      break
    case 'locale-date':
      formatToken = 'short'
      break
    case 'locale-long-date':
      formatToken = 'long'
      break
    case 'locale-mn':
      formatToken = { date: 'short', time: 'short' } as FormatStyleObj
      break
    case 'locale-sec':
      formatToken = { date: 'short', time: 'medium' } as FormatStyleObj
      break
    case 'month-year':
      formatToken = 'MMMM YYYY'
      break
  }

  const { $i18n } = useNuxtApp()
  return tempoFormat(date, formatToken, $i18n.locale.value)
}
